module.exports = __webpack_public_path__ + "static/media/black-tick-icon-24x24.36b22c28.svg";